import classNames from './styles.scss'

export {classNames}
export {default} from './template'

export const RECORD_WIDTH = 197
export const RECORD_INDENT = 10
